// https://github.com/reactjs/redux/issues/99

export default function(state = {}, action) {
  const typeMap = {
    WP_PAGE_LOADING() {
      return {
        isLoading: true,
        wpPage: action.wpPage
      };
    },
    WP_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.wpPage
      };
    },
    WP_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.wpPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
